const MAX_SIZE = 1600;

// Downscale photos in the browser before upload: phone photos are often 5-10 MB.
// Falls back to the original file if the browser can't decode it (e.g. HEIC on desktop Chrome).
// The full-size bitmap and the canvas are freed straight away: iOS Safari caps the memory all canvases on a
// page may use, and past that cap a canvas silently draws nothing (a blank or half-drawn photo is uploaded).
export const resizeImage = async (file, maxSize = MAX_SIZE) => {
  let bitmap;
  const canvas = document.createElement('canvas');
  try {
    bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxSize / Math.max(bitmap.width, bitmap.height));
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const context = canvas.getContext('2d');
    if (!context) return file;
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return file;
  } finally {
    bitmap?.close();
    canvas.width = 0;
    canvas.height = 0;
  }
};

// Several photos one after another, never at once: decoding them together is what runs iOS out of canvas memory.
export const resizeImages = async (files, maxSize = MAX_SIZE) => {
  const resized = [];
  for (const file of files) resized.push(await resizeImage(file, maxSize)); // eslint-disable-line no-await-in-loop
  return resized;
};
